import { render, staticRenderFns } from "./GameItem.vue?vue&type=template&id=863e833a"
import script from "./GameItem.vue?vue&type=script&lang=js"
export * from "./GameItem.vue?vue&type=script&lang=js"
import style0 from "./GameItem.vue?vue&type=style&index=0&id=863e833a&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('863e833a')) {
      api.createRecord('863e833a', component.options)
    } else {
      api.reload('863e833a', component.options)
    }
    module.hot.accept("./GameItem.vue?vue&type=template&id=863e833a", function () {
      api.rerender('863e833a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/GameItem.vue"
export default component.exports